export const normalizeAuthToken = (rawToken: string | null): string | null => {
  if (typeof rawToken !== "string") {
    return null;
  }

  let normalized = rawToken.trim();
  if (!normalized) {
    return null;
  }

  if (normalized.startsWith('"') && normalized.endsWith('"')) {
    normalized = normalized.slice(1, -1).trim();
  }

  if (normalized.startsWith("'") && normalized.endsWith("'")) {
    normalized = normalized.slice(1, -1).trim();
  }

  normalized = normalized.replace(/^Bearer\s+/i, "").trim();

  try {
    const decoded = decodeURIComponent(normalized);
    if (decoded) {
      normalized = decoded.trim();
    }
  } catch {
    // Keep original token when decode fails.
  }

  return normalized || null;
};
